export default {
  success: {
    successfully: '{key} 성공',
    copyToClipboard: '클립 보드로 복사됨',
    approved: '{key}가 승인되었습니다',
    processed: '{key} 처리가 완료되었습니다',
    uploaded: '{key} 업로드가 완료되었습니다',
    register: '가입 성공, 로그인해 주세요',
  },
  warning: {
    rejected: '{key}가 거부되었습니다',
    removeFxRateTemplate: '경고: "{name}" 템플릿이 고객, 기관 및 에이전트에서 동시에 제거됩니다.',
    transferFromIt: '모든 잔액 [예상: {amount}]을 {from}에서 {to}로 이체하시겠습니까?',
    clearBrowserCache: '이 작업은 브라우저 캐시를 지우고 다음 기본 설정으로 복원합니다:',
    forcedRefresh: '*주의: 현재 페이지가 강제로 새로 고침됩니다!',
    resetPassword1: '이메일 발송 중 곧 이메일이 도착합니다.',
    resetPassword2: '{email}',
    resetPassword3: '계정(비밀번호)을 찾는 데 도움이 됩니다',
  },
  error: {
    required: '필수 입력 항목',
    duplicatedBy: '{target}와(과) 중복될 수 없습니다',
    symbolExisted: '이미 존재하는 symbol 입니다',
    failed: '{key} 실패',
    serverUnavailable: '현재 서버를 이용할 수 없습니다. 나중에 다시 시도하십시오',
    uploadFileType: '파일 형식은 {types}만 업로드 가능합니다',
    uploadFileSize: '파일 크기는 {maxSize}MB를 초과할 수 없습니다',
    uploadFailed: '업로드 실패',
    underLength: '길이가 부족합니다 [{min}]',
    overLength: '길이 초과 범위 [{max}]',
    decimalOverLength: '길이 초과 범위 [{precision}, {scale}]',
    underflow: '최솟값 [{min}] 미만',
    overflow: '최댓값 [{max}] 초과',
    invalidMailFormat: '유효하지 않은 이메일 형식',
    invalidMobileFormat: '잘못된 휴대폰 번호',
    notOnlyNumber: '숫자만 입력할 수 없습니다',
    notOnlyLetter: '문자만 입력할 수 없습니다',
    atLeastOneLowercase: '최소한 하나의 소문자 필요',
    atLeastOneUppercase: '최소한 하나의 대문자 필요',
    atLeastOneNumber: '최소한 하나의 숫자 필요',
    onlyAlphanumerical: '알파벳 및 숫자 조합만 허용됩니다',
    cannotBeSuperuser: '슈퍼 사용자가 될 수 없습니다',
    mustBeSuperuser: '슈퍼 사용자여야 합니다',
    mustBeGreaterThan: '{number}보다 커야 합니다',
    ranges: '범위: {min}~{max}',
    lengthLimit: '길이는 {length}여야 합니다',
    notSame: '입력하신 비밀번호가 일치하지 않습니다',
    notBlank: '비어 있지 않음',
    containsSpace: '공백을 포함할 수 없습니다',
  },
  confirm: {
    title: '{action}하시겠습니까?',
    resourceNotFoundTitle: '자원 기간 만료됨',
    resourceNotFoundContent: '최신 리소스를 업데이트하기 위해 페이지를 새로고침 하시겠습니까?',
  },
  modal: {
    add: '{name} 추가',
    edit: '{name} 편집',
    detail: '{name} 세부 정보',
  },
  pagination: {
    showTotal: `{start}-{end} 총 {total} 개의 데이터`,
  },
  tooltip: {
    settings: '이 설정은 브라우저 캐시에 저장됩니다',
  },
  message: {
    itReceiveCheck: '기관 수금 계좌 인증 통과됨',
    needToCreateUsdReceiveAccount: '기관 수금 계좌 인증 실패, "미국 달러" 수금 계좌를 생성해야 합니다',
  },
};
